// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","emailInput":"Ge18897","button":"G199e14","emailSentNotification":"G44be33"};